<template>
  <div v-if="isPreparing">
    <Preparing></Preparing>
  </div>
  <div v-if="!isPreparing">
    <div class="container-fluid">
      <div class="casrd carsd-item">
        <div class="card-body">
          <div class="d-flex justify-content-between">
            <div class="dashboard-heading mb-5">
              <h3 class="font-weight-bold">{{ calcTitle() }}</h3>
            </div>

            <div
              v-if="showCourse"
              class="dashboard-heading mb-5"
              title="بازگشت به لیست کلاس ها"
            >
              <i
                @click="showCourse = false"
                class="la la-arrow-left brr35 icon-bg-white p-2 crToPoi fs-28"
              ></i>
            </div>
          </div>
          <h4 v-if="showCourse" class="pb-2 font-weight-semi-bold">
            ایجاد جلسه جدید
          </h4>

          <div v-if="showCourse" class="d-flex flex-md-row flex-column">
            <div class="col-lg-9 col-12">
              <div
                class="card card-item5 card-item-course dashboard-info-card p-3"
              >
                <div class="d-flex row p-2">
                  <div class="col-lg-6 form-group">
                    <label class="label-text">عنوان جلسه</label>
                    <input
                      onfocus="this.removeAttribute('readonly');"
                      readonly
                      v-model="CreatingSessionTitle"
                      class="form-control form-control-register pl-3"
                      type="text"
                      placeholder="عنوان جلسه را وارد کنید"
                    />
                  </div>

                  <div class="col-lg-6 form-group">
                    <label class="label-text">لینک جلسه</label>
                    <input
                      onfocus="this.removeAttribute('readonly');"
                      readonly
                      v-model="CreatingSessionLink"
                      class="form-control form-control-register pl-3"
                      type="text"
                      style="direction: ltr"
                      placeholder="https://example...."
                    />
                  </div>
                  <div class="col-lg-6 mb-3">
                    <label class="form-label">زمان برگزاری</label>
                    <datePicker
                      placeholder="تاریخ و ساعت برگزاری را وارد کنید"
                      class="col-lg-6 px-2"
                      type="datetime"
                      v-model="CreatingSessionDate"
                    />
                  </div>
                  <div class="col-lg-6 mb-3">
                    <label class="form-label">توضیحات</label>
                    <textarea
                      class="form-control form-control-register pl-3"
                      placeholder="توضیحات خود را اینجا وارد کنید"
                      v-model="CreatingSessionDisc"
                      rows="4"
                    ></textarea>
                  </div>
                </div>
                <div class="d-flex justify-content-center col-lg-12">
                  <button
                    @click="addSession()"
                    :disabled="addingSession"
                    type="button"
                    class="btn mx-lg-2 my-1 my-lg-0 py-2 fs-12 hovtolightbtn theme-btn-blue2-small mx-2"
                  >
                    <div v-if="!addingSession">+ افزودن جلسه</div>
                    <div
                      v-if="addingSession"
                      class="spinner-border"
                      role="status"
                    ></div>
                  </button>
                </div>
              </div>

              <h4 class="pt-3 pb-1 pl-2 font-weight-bold">جلسات</h4>

              <div
                v-for="(item, index) in sessions"
                :key="index"
                id="download-app"
                class="card card-item5 card-item-course dashboard-info-card mt-3 p-4"
              >
                <div
                  class="d-flex flex-column flex-md-row justify-content-between align-items-center"
                >
                  <div>
                    <h6 class="pb-2">{{ item.Title }}</h6>
                    <span class="pt-2"
                      >تاریخ برگزاری:
                      <span class="light-blue-text"
                        >{{ parseDates(item.DateStart) }}
                        <span class="pl-5 grey-text"
                          >ساعت شروع:
                          <span class="light-blue-text"
                            >{{ parseTimes(item.DateStart)
                            }}<span></span></span></span></span
                    ></span>
                  </div>
                  <div class="d-flex">
                    <button
                      :disabled="gettingSessionFiles"
                      @click="getSessionFiles(item)"
                      type="button"
                      class="btn mx-lg-2 my-1 my-lg-0 py-2 fs-12 hovtolightbtn theme-btn-purple2-small mx-2"
                    >
                      <div
                        v-if="
                          !gettingSessionFiles || selectedSession.Id !== item.Id
                        "
                      >
                        دانلود فایل ها
                      </div>
                      <div
                        v-if="
                          gettingSessionFiles && selectedSession.Id === item.Id
                        "
                        class="spinner-border"
                        role="status"
                      ></div>
                    </button>

                    <button
                      type="button"
                      class="btn mx-lg-2 my-1 my-lg-0 py-2 fs-12 hovtolightbtn theme-btn-blue2-small mx-2"
                    >
                      <a class="text-white" :href="item.Link">ورود به جلسه</a>
                    </button>
                    <div
                      class="generic-action-wrap generic--action-wrap-3 d-flex justify-content-center align-items-center"
                    >
                      <div class="dropdown">
                        <a
                          class="action-btn"
                          href="#"
                          role="button"
                          id="dropdownMenuLinkFour"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                        >
                          <i class="la la-ellipsis-v"></i>
                        </a>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuLinkFour"
                        >
                          <a
                            @click="selectedSession = item"
                            data-toggle="modal"
                            data-target="#addFileModal"
                            class="dropdown-item m-0 crToPoi"
                            >افزودن فایل</a
                          >
                          <a
                            @click="sendEditSession(item)"
                            data-toggle="modal"
                            data-target="#editSessionModal"
                            class="dropdown-item m-0 crToPoi"
                            >ویرایش جلسه</a
                          >
                          <a
                            @click="sendNotiSession(item)"
                            data-toggle="modal"
                            data-target="#notiSessionModal"
                            class="dropdown-item m-0 crToPoi"
                            >ارسال اطلاعیه</a
                          >
                          <a
                            @click="selectedSession = item"
                            data-toggle="modal"
                            data-target="#deleteSessionModal"
                            class="dropdown-item m-0 crToPoi"
                            >حذف جلسه</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-12">
              <div
                class="card d-flex justify-content-center align-items-center card-item5 pt-5 mt-5 mt-md-0 pb-2 px-4"
              >
                <img
                  :width="90"
                  :height="90"
                  style="object-fit: cover !important"
                  :src="domain + clickedClass.Image"
                  class="rounded-custom1 lazy"
                />
                <div
                  class="card-body d-flex align-items-center flex-column pt-2 px-0"
                >
                  <div class="pb-1">
                    <p
                      class="black-text text-center font-weight-semi-bold small-course-items"
                    >
                      عنوان کلاس:
                    </p>
                    <span
                      class="black-text font-weight-semi-bold small-course-items"
                      >{{ clickedClass.Name }}</span
                    >
                  </div>

                  <div
                    class="d-flex justify-content-start flex-column align-items-start"
                  >
                    <div class="py-2">
                      <span class="black-text smaller-course-items2"
                        >دسته بندی: </span
                      ><span class="smaller-course-items2 grey-text">
                        {{ clickedClass.Category }}
                      </span>
                    </div>
                    <div class="pb-2">
                      <span class="black-text smaller-course-items2"
                        >نوع کلاس: </span
                      ><span class="smaller-course-items2 light-blue-text">
                        {{ clickedClass.Private ? "خصوصی" : "عمومی" }}
                      </span>
                    </div>
                    <div class="pb-2">
                      <span class="black-text smaller-course-items2"
                        >تعداد شرکت کننده: </span
                      ><span class="black-text smaller-course-items2">
                        {{ clickedClass.Capacity }} نفر
                      </span>
                    </div>
                  </div>
                </div>
                <!-- end card-body -->
              </div>
              <Preparing v-if="gettingDetail" />

              <div
                v-if="showStudentDetail && !gettingDetail"
                class="card d-flex justify-content-center align-items-center card-item5 pt-5 mt-5 pb-2 px-4"
              >
                <div
                  v-if="!gettingDetail"
                  class="d-flex justify-content-between align-items-center"
                >
                  <span class="px-2">مشخصات شرکت کننده</span>

                  <div
                    v-if="showStudentDetail"
                    class="dashboard-heading"
                    title="بازگشت به لیست دانشجویان"
                  >
                    <i
                      @click="showStudentDetail = false"
                      class="la la-arrow-left brr35 icon-bg-white p-2 crToPoi fs-12"
                    ></i>
                  </div>
                </div>
                <div class="d-flex flex-column align-items-start">
                  <div class="pt-4 pb-2">
                    <span class="black-text smaller-course-items2">نام: </span
                    ><span class="smaller-course-items2 grey-text">
                      {{ studentInfo.Name }}
                    </span>
                  </div>
                  <div class="pb-2">
                    <span class="black-text smaller-course-items2">ایمیل: </span
                    ><span class="smaller-course-items2 grey-text">
                      {{ studentInfo.Email }}
                    </span>
                  </div>
                  <div class="pb-2">
                    <span class="black-text smaller-course-items2"
                      >سطح زبان: </span
                    ><span class="smaller-course-items2 grey-text">
                      {{ studentInfo.EnglishLevel }}
                    </span>
                  </div>
                  <div class="pb-2">
                    <span class="black-text smaller-course-items2"
                      >رشته تحصیلی: </span
                    ><span class="smaller-course-items2 grey-text">
                      {{ studentInfo.Degree }}
                    </span>
                  </div>
                  <div class="pb-2">
                    <span class="black-text smaller-course-items2"
                      >هدف دانشجو: </span
                    ><span class="smaller-course-items2 grey-text">
                      {{ selectedStudent.Target }}
                    </span>
                  </div>
                </div>
                <div class="divider w-85"></div>
              </div>
              <div
                v-if="!showStudentDetail"
                class="card d-flex justify-content-center align-items-center card-item5 pt-5 mt-5 pb-2 px-4"
              >
                <h6>لیست شرکت کنندگان:</h6>
                <div class="py-3 form-group">
                  <input
                    onfocus="this.removeAttribute('readonly');"
                    readonly
                    v-model="searchStudents"
                    class="form-control form-control2 form-control-register2 pl-3"
                    type="text"
                    placeholder="جستجوی شرکت کنندگان"
                  />
                </div>
                <div
                  v-for="(st, index) in filteredStudents"
                  :key="index"
                  @click="showStudentDetailFunc(st)"
                  class="crToPoi col-11 d-flex align-items-center justify-content-between pt-2 px-1"
                >
                  <span class="d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-person-circle"
                      viewBox="0 0 16 16"
                    >
                      <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                      <path
                        fill-rule="evenodd"
                        d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                      />
                    </svg>
                    <span class="px-1">{{ st.Name }}</span>
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-arrow-left-short"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                    />
                  </svg>
                </div>
                <div class="divider w-85"></div>
              </div>
            </div>
          </div>
          <DataTable
            ref="dt"
            :filters="filters"
            class="p-datatable-lg"
            :rowHover="true"
            :value="courses"
            :paginator="true"
            :stripedRows="true"
            :rows="10"
            v-if="!showCourse"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="نمایش {first} تا {last} از {totalRecords}"
            stateStorage="local"
            stateKey="dt-state-demo-local"
            pv_id_1
          >
            <template #header>
              <div
                class="table-header flex flex-column md:flex-row md:justiify-content-between"
              >
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText
                    class="form-control-register"
                    v-model="filters['global'].value"
                    placeholder="جستجو کنید"
                  />
                </span>
              </div>
            </template>
            <Column
              :style="{ textAlign: 'right' }"
              field="Name"
              header="مشخصات کلاس"
            >
              <template #body="slotProps">
                <div class="d-flex justify-content-start align-items-center">
                  <img
                    :src="domain + slotProps.data.Image"
                    style="
                      aspect-ratio: 1;
                      object-fit: cover;
                      border-radius: 20px;
                    "
                    :width="80"
                  />
                  <div
                    class="d-flex pl-4 flex-column align-items-start justify-content-center"
                  >
                    <p class="py-2 fs-14 purple-text fs-16 font-weight-bold">
                      {{ slotProps.data.Name }}
                    </p>
                    <p class="py-2 purple-text">
                      دسته بندی:
                      <span class="black-text">{{
                        slotProps.data.Category
                      }}</span>
                    </p>
                  </div>
                </div>
              </template>
            </Column>
            <Column
              :style="{ textAlign: 'right' }"
              field="Category"
              header="نوع کلاس"
            >
              <template #body="slotProps">
                <h6 v-if="!slotProps.data.Private" class="light-blue-text">
                  عمومی
                </h6>
                <h6 v-else class="dark-blue-text">خصوصی</h6>
              </template>
            </Column>
            <Column
              :style="{ textAlign: 'right' }"
              field="Status"
              header="ظرفیت"
            >
              <template #body="slotProps">
                <h6>
                  {{ slotProps.data.Remaining }}/{{ slotProps.data.Capacity }}
                </h6>
              </template>
            </Column>
            <Column
              :style="{ textAlign: 'right' }"
              field="Status"
              header="وضعیت"
            >
              <template #body="slotProps">
                <h6 v-if="ifIsBefore(slotProps.data.DateEnd)">شروع شده</h6>
                <h6 v-else>در حال ثبت نام</h6>
              </template>
            </Column>

            <Column :style="{ textAlign: 'center' }" :exportable="false">
              <template #body="slotProps">
                <div class="d-flex">
                  <button
                    v-if="ifIsBefore2(slotProps.data.DateEnd)"
                    @click="getCourseCreds(slotProps.data)"
                    type="button"
                    class="btn mx-lg-2 my-1 my-lg-0 py-3 fs-18 hovtolightbtn theme-btn-darkblue2 mx-2"
                  >
                    جزئیات بیشتر
                  </button>
                  <span v-else>هنوز کلاس شروع نشده است</span>
                </div>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade modal-container" id="seeFilesModal">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">فایل های {{ selectedSession.Title }}</h4>
          <button type="button" class="close" data-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body d-flex row mx-3 justify-content-center my-2">
          <div
            v-if="clickedSessionFiles.length === 0"
            class="d-flex justify-content-center align-items-center"
          >
            <h5 class="py-5">تاکنون فایلی برای این جلسه ثبت نشده است.</h5>
          </div>
          <div
            v-for="(item, index) in clickedSessionFiles"
            :key="index"
            class="card col-lg-9 card-item6 m-2 card-item-course dashboard-info-card p-4"
          >
            <div
              class="d-flex flex-column flex-md-row justify-content-between align-items-center"
            >
              <div>
                <p class="pb-2">{{ item.Title }}</p>
              </div>
              <div class="d-flex">
                <button
                  data-toggle="modal"
                  data-target="#seeFilesModal"
                  type="button"
                  class="btn mx-lg-2 my-1 my-lg-0 py-2 fs-12 hovtolightbtn theme-btn-purple2-small mx-2"
                >
                  <a class="text-white" :href="domain + item.File"
                    >دانلود فایل</a
                  >
                </button>
                <button
                  @click="deleteSessionFile(item)"
                  :disabled="deletingSessionFiles"
                  type="button"
                  class="btn mx-lg-2 my-1 my-lg-0 py-2 fs-12 hovtodangerbtn theme-btn-danger-small mx-2"
                >
                  <div v-if="!deletingSessionFiles">حذف فایل</div>
                  <div
                    v-if="deletingSessionFiles"
                    class="spinner-border"
                    role="status"
                  ></div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade modal-container" id="addFileModal">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            افزودن فایل برای جلسه {{ selectedSession.Title }}
          </h4>
          <button type="button" class="close" data-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body d-flex row mx-3 justify-content-start my-2">
          <div class="col-lg-12 form-group">
            <label class="label-text">عنوان فایل</label>
            <input
              onfocus="this.removeAttribute('readonly');"
              readonly
              v-model="addingUploadTitle"
              class="form-control form-control-register pl-3"
              type="text"
              placeholder="عنوان فایل را وارد کنید "
            />
          </div>
          <div class="col-lg-12 form-group mb-0">
            <label class="label-text">فایل انتخابی</label>
            <div class="file-upload-wrap">
              <input
                onfocus="this.removeAttribute('readonly');"
                readonly
                type="file"
                v-on:change="handleAddedFileUpload($event)"
                class="file-upload-input"
              />
              <span class="file-upload-text"
                ><i class="la la-cloud-upload mr-2 fs-18"></i>تصاویر را اینجا
                رها کنید یا برای آپلود کلیک کنید.</span
              >
            </div>
          </div>
          <ProgressBar
            v-if="addingFile"
            class="col-12"
            :showValue="addingFile"
            :value="progressValue"
          />

          <div class="col-12 py-3 d-flex justify-content-center">
            <button
              @click="addFile()"
              :disabled="addingFile"
              type="button"
              class="btn mx-lg-2 my-1 my-lg-0 py-2 fs-12 hovtolightbtn theme-btn-blue2-small mx-2"
            >
              <div v-if="!addingFile">+ افزودن فایل</div>
              <div v-if="addingFile" class="spinner-border" role="status"></div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade modal-container"
    id="deleteClassModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="deleteClassModalTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="la la-exclamation-circle fs-60 text-warning"></span>
          <h4
            class="modal-title fs-19 font-weight-semi-bold pt-2 pb-1"
            id="deleteClassModalTitle"
          >
            {{ selectedCourse.Name }} برای همیشه حذف خواهد شد!
          </h4>
          <p>
            آیا مطمئن هستید که می خواهید {{ selectedCourse.Name }} را حذف کنید؟
          </p>
          <div class="btn-box pt-4">
            <button
              type="button"
              class="btn font-weight-medium mr-3"
              data-dismiss="modal"
            >
              لغو کنید
            </button>
            <button
              @click="deleteCourse(selectedCourse)"
              type="submit"
              class="btn theme-btn theme-btn-sm lh-30"
              data-dismiss="modal"
            >
              باشه حذف کن
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade modal-container"
    id="notiSessionModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="notiSessionModalTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            {{ notiSessionItem.Title }} ارسال اطلاعیه -
          </h4>
          <button type="button" class="close" data-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <div class="d-flex justify-content-around py-4">
            <div class="custom-control custom-checkbox fs-21">
              <input
                v-model="selectSMS"
                :value="true"
                type="checkbox"
                class="custom-control-input"
                id="rememberMeCheckbox2"
              />
              <label
                class="custom-control-label custom--control-label"
                for="rememberMeCheckbox2"
                >ارسال به صورت پیامک</label
              >
            </div>
            <div class="custom-control custom-checkbox fs-21">
              <input
                v-model="selectEmail"
                :value="true"
                type="checkbox"
                class="custom-control-input"
                id="rememberMeCheckbox3"
              />
              <label
                class="custom-control-label custom--control-label"
                for="rememberMeCheckbox3"
                >ارسال به صورت ایمیل</label
              >
            </div>
          </div>
          <div class="d-flex justify-content-center py-4 col-lg-12">
            <button
              data-dismiss="modal"
              @click="
                notiApi(
                  false,
                  false,
                  'create',
                  true,
                  parseDatest(notiSessionItem.DateStart),
                  notiSessionItem.Title,
                  notiSessionItem.Link
                )
              "
              :disabled="notiting"
              type="button"
              class="btn mx-lg-2 my-1 my-lg-0 py-2 fs-12 hovtolightbtn theme-btn-blue2-small mx-2"
            >
              <div v-if="!notiting">ارسال</div>
              <div v-if="notiting" class="spinner-border" role="status"></div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade modal-container"
    id="editSessionModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="editSessionModalTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ editingSessionItemTitle }} ویرایش</h4>
          <button type="button" class="close" data-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="p-3">
            <div class="d-flex row p-2">
              <div class="col-lg-6">
                <label class="label-text">عنوان جلسه</label>
                <input
                  onfocus="this.removeAttribute('readonly');"
                  readonly
                  v-model="editingSessionItem.Title"
                  class="form-control form-control-register pl-3"
                  type="text"
                  placeholder="عنوان جلسه را وارد کنید"
                />
              </div>

              <div class="col-lg-6 form-group">
                <label class="label-text">لینک جلسه</label>
                <input
                  onfocus="this.removeAttribute('readonly');"
                  readonly
                  v-model="editingSessionItem.Link"
                  class="form-control form-control-register pl-3"
                  type="text"
                  style="direction: ltr"
                  placeholder="https://example...."
                />
              </div>
              <div class="col-lg-6 mb-3">
                <label class="form-label">زمان برگزاری</label>
                <datePicker
                  placeholder="تاریخ و ساعت برگزاری را وارد کنید"
                  class="col-lg-6 px-2"
                  type="datetime"
                  v-model="editingSessionItem.DateStart"
                />
              </div>
              <div class="col-lg-6 mb-3">
                <label class="form-label">توضیحات</label>
                <textarea
                  class="form-control form-control-register pl-3"
                  placeholder="توضیحات خود را اینجا وارد کنید"
                  v-model="editingSessionItem.Disc"
                  rows="4"
                ></textarea>
              </div>
            </div>
            <div class="d-flex justify-content-center col-lg-12">
              <button
                @click="editSession()"
                :disabled="editingSession"
                type="button"
                class="btn mx-lg-2 my-1 my-lg-0 py-2 fs-12 hovtolightbtn theme-btn-blue2-small mx-2"
              >
                <div v-if="!editingSession">ویرایش جلسه</div>
                <div
                  v-if="editingSession"
                  class="spinner-border"
                  role="status"
                ></div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade modal-container"
    id="deleteSessionModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="deleteSessionModalTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="la la-exclamation-circle fs-60 text-warning"></span>
          <h4
            class="modal-title fs-19 font-weight-semi-bold pt-2 pb-1"
            id="deleteSessionModalTitle"
          >
            {{ selectedSession.Title }} برای همیشه حذف خواهد شد!
          </h4>
          <p>
            آیا مطمئن هستید که می خواهید {{ selectedSession.Title }} را حذف
            کنید؟
          </p>
          <div class="btn-box pt-4">
            <button
              type="button"
              class="btn font-weight-medium mr-3"
              data-dismiss="modal"
            >
              لغو کنید
            </button>
            <button
              data-dismiss="modal"
              @click="deleteSession()"
              type="button"
              class="btn theme-btn theme-btn-sm lh-30"
            >
              تایید و حذف
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Toast position="top-left" />
</template>

<script>
import axios from "axios";
import router from "../router/index";
import { FilterMatchMode } from "primevue/api";
import ls from "localstorage-slim";
import Preparing from "../components/Preparing.vue";
import { courseStatuses } from "../constants";
import Vue3PersianDatetimePicker from "vue3-persian-datetime-picker";
import { DOMAIN } from "../configs";
import moment from "jalali-moment";
import * as moment1 from "moment";

export default {
  name: "MyOnlineClasses",
  components: {
    Preparing,
    datePicker: Vue3PersianDatetimePicker,
  },
  data() {
    return {
      editingSessionItemTitle: "",

      deletingSessionFiles: false,

      selectEmail: false,
      selectSMS: false,
      notiting: false,
      notiSessionItem: {},
      editingSessionItem: {},
      editingSession: false,
      selectedStudent: {},
      sessions: [],
      clickedSessionFiles: [],
      deletingSession: false,
      gettingSessionFiles: false,
      progressValue: 0,
      addingUploadTitle: "",
      addingUploadFile: "",
      addingFile: false,
      searchStudents: "",
      addingSession: false,
      gettingDetail: false,
      clickedClass: {},
      studentInfo: {},
      selectedSession: {},
      selectedCourse: {},
      domain: DOMAIN,
      showStudentDetail: false,
      CreatingSessionDisc: "",
      CreatingSessionTitle: "",
      CreatingSessionLink: "",
      CreatingSessionDate: "",
      showCourse: false,
      courseStatus: courseStatuses,
      isPreparing: true,
      me: {},
      courses: [],
      students: [],
      filteredStudents: [],
      filters: {},
      course: {},
      submitted: false,
      deleteCourseDialog: false,
      selectedCourse: "",
      todayDate: "",
    };
  },
  watch: {
    searchStudents() {
      this.filteredStudents = this.students.filter((s) =>
        s.Name.includes(this.searchStudents)
      );
    },
  },
  mounted() {
    moment.locale("fa", { useGregorianParser: true });

    var today = new Date();
    let date = new Intl.DateTimeFormat("en-US-u-ca-persian").format(today);
    date = date.split(" ")[0];
    date =
      date.split("/")[2] + "/" + date.split("/")[0] + "/" + date.split("/")[1];
    this.todayDate = date;
    this.getCredentials();
  },
  created() {
    this.initFilters();
  },
  methods: {
    async editSession() {
      if (
        this.editingSessionItem.Title === "" ||
        this.editingSessionItem.Link === "" ||
        this.editingSessionItem.DateStart === ""
      ) {
        this.$toast.add({
          severity: "error",
          detail: "لطفا تمام موارد را وارد کنید",
          life: 5000,
        });
        return;
      }
      this.editingSession = true;
      await axios
        .post("/api/v1/manager/class/session/edit", {
          id: this.editingSessionItem.Id,
          title: this.editingSessionItem.Title,
          disc: this.editingSessionItem.Disc,
          link: this.editingSessionItem.Link,
          startdate: this.editingSessionItem.DateStart,
        })
        .then(async (response) => {
          if (response.data.status === "ok") {
            this.notiApi(
              true,
              true,
              "create",
              false,
              this.editingSessionItem.DateStart,
              this.editingSessionItem.Title,
              this.editingSessionItem.Link
            );

            await axios
              .post("/api/v1/manager/class/session", {
                id: this.clickedClass.Id,
              })
              .then((response) => {
                this.sessions = response.data.data;
              })
              .catch((e) => {
                this.isPreparing = false;
                this.showCourse = false;
              });
            this.editingSession = false;
            this.$toast.add({
              severity: "success",
              summary: "جلسه با موفقیت ویرایش شد",
              life: 5000,
            });
          } else {
            this.editingSession = false;
            this.$toast.add({
              severity: "error",
              summary: "خطای سرور",
              life: 5000,
            });
          }
        })
        .catch((e) => {
          this.editingSession = false;
        });
    },
    async notiApi(
      platformsms,
      platformemail,
      modifymode,
      frommodal,
      startdate,
      title,
      link
    ) {
      if (this.selectSMS === false && this.selectEmail === false && frommodal) {
        this.$toast.add({
          severity: "error",
          summary: "لطفا یکی از اطلاعیه ها را انتخاب کنید",
          life: 5000,
        });
        return;
      }
      if (this.selectEmail || platformemail) {
        this.notiting = true;
        await axios
          .post(`/api/v1/manager/class/noti/send/email/${modifymode}`, {
            id: this.clickedClass.Id,
            startdate: startdate,
            title: title,
            link: link,
          })
          .then((response) => {
            this.notiting = false;
          })
          .catch((e) => {
            this.notiting = false;
          });
      }

      if (this.selectSMS || platformsms) {
        this.notiting = true;

        await axios
          .post(`/api/v1/manager/class/noti/send/sms/${modifymode}`, {
            id: this.clickedClass.Id,
            startdate: startdate.replace(" ", "-"),
            title: title,
            link: link,
            classname: this.clickedClass.Name,
          })
          .then((response) => {
            this.notiting = false;
          })
          .catch((e) => {
            this.notiting = false;
          });
      }
    },

    sendEditSession(s) {
      this.editingSessionItem = { ...s };
      this.editingSessionItemTitle = s.Title;
      moment.locale("fa", { useGregorianParser: true });

      this.editingSessionItem.DateStart = moment(
        this.editingSessionItem.DateStart
      ).format("jYYYY/jM/jD HH:mm:ss");
    },
    sendNotiSession(s) {
      this.notiSessionItem = s;
    },
    async addFile() {
      if (this.addingUploadFile === "" || this.addingUploadTitle === "") {
        this.$toast.add({
          severity: "error",
          summary: "لطفا فایل و عنوان را وارد کنید",
          life: 5000,
        });
        return;
      }
      this.addingFile = true;
      let formData = new FormData();
      formData.append("File", this.addingUploadFile[0]);
      formData.append("uidsession", this.selectedSession.Uid);
      formData.append("title", this.addingUploadTitle);
      formData.append("classid", this.clickedClass.Id);
      await axios
        .post("/api/v1/teacher/class/add/file/session", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.progressValue = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then((response) => {
          if (response.data.data === "ok") {
            this.addingUploadFile = "";
            this.addingUploadTitle = "";
            this.$toast.add({
              severity: "success",
              summary: "فایل با موفقیت ثبت شد",
              life: 5000,
            });
            this.addingFile = false;
          } else {
            this.addingUploadFile = "";
            this.addingUploadTitle = "";
            this.$toast.add({
              severity: "error",
              summary: "خطا در ثبت فایل",
              life: 5000,
            });
          }
        })
        .catch((e) => {
          this.addingUploadFile = "";
          this.addingUploadTitle = "";
          this.$toast.add({
            severity: "error",
            summary: "خطای سرور",
            life: 5000,
          });
          this.addingFile = false;
        });
    },
    async deleteCourse(c) {
      await axios
        .post("/api/v1/teacher/class/delete", { id: c.Id })
        .then((response) => {
          if (response.data.data === "ok") {
            this.$toast.add({
              severity: "success",
              summary: "کلاس با موفقیت حذف شد",
              life: 5000,
            });
            this.courses = this.courses.filter((p) => p.Id !== c.Id);
          } else {
            this.$toast.add({
              severity: "error",
              summary: "امکان حذف کلاس وجود ندارد",
              life: 5000,
            });
          }
        });
    },
    async deleteSessionFile(f) {
      this.deletingSessionFiles = true;
      await axios
        .post("/api/v1/teacher/class/delete/file/session", {
          uid: f.Uid,
        })
        .then((response) => {
          this.$toast.add({
            severity: "success",
            summary: "فایل با موفقیت حذف شد",
            life: 5000,
          });
          this.clickedSessionFiles = this.clickedSessionFiles.filter(
            (s) => s.Id !== f.Id
          );
          this.deletingSessionFiles = false;
        })
        .catch((e) => {
          this.$toast.add({
            severity: "error",
            summary: "خطای سرور",
            life: 5000,
          });
          this.deletingSessionFiles = false;
        });
    },
    async deleteSession() {
      this.deletingSession = true;
      await axios
        .post("/api/v1/teacher/class/session/delete", {
          uid: this.selectedSession.Uid,
        })
        .then((response) => {
          if (response.data.data === "ok") {
            this.notiApi(
              true,
              true,
              "delete",
              false,
              this.parseDatest(this.selectedSession.DateStart),
              this.selectedSession.Title,
              this.selectedSession.Link
            );

            this.deletingSession = false;
            this.$toast.add({
              severity: "success",
              summary: "جلسه با موفقیت حذف شد",
              life: 5000,
            });
            this.sessions = this.sessions.filter(
              (p) => p.Id !== this.selectedSession.Id
            );
          } else {
            this.deletingSession = false;

            this.$toast.add({
              severity: "error",
              summary: "امکان حذف جلسه وجود ندارد",
              life: 5000,
            });
          }
        })
        .catch((e) => {
          this.deletingSession = false;

          this.$toast.add({
            severity: "error",
            summary: "خطای سرور",
            life: 5000,
          });
        });
    },
    ifIsBefore(d) {
      if (
        moment.from(d, "YYYY/M/D").isBefore(moment.from(moment(), "YYYY/M/D"))
      ) {
        return true;
      } else {
        return false;
      }
    },
    ifIsBefore2(d) {
      if (
        moment.from(d, "YYYY/M/D").isBefore(moment.from(moment(), "YYYY/M/D"))
      ) {
        return true;
      } else {
        return false;
      }
    },
    async showStudentDetailFunc(v) {
      this.selectedStudent = v;
      this.gettingDetail = true;
      await axios
        .post("/api/v1/teacher/class/get/student/detail", {
          id: this.clickedClass.Id,
          stid: v.StudentId,
        })
        .then((response) => {
          this.studentInfo = response.data.Student;
          this.showStudentDetail = true;
        })
        .catch((e) => {
          this.gettingDetail = false;
        });
      this.gettingDetail = false;
    },
    handleAddedFileUpload(event) {
      if (event.target.files[0].size > 2000000000) {
        this.$toast.add({
          severity: "error",
          summary: "فایل انتخابی نباید بیش از 2 گیگابایت باشد",
          life: 5000,
        });
        return;
      }
      this.addingUploadFile = event.target.files;
    },
    async getSessionFiles(s) {
      this.selectedSession = s;
      this.gettingSessionFiles = true;
      await axios
        .post("/api/v1/teacher/class/get/file/session", {
          uidsession: s.Uid,
        })
        .then((response) => {
          this.clickedSessionFiles = response.data.data;
          this.openModal("seeFilesModal");
          this.gettingSessionFiles = false;
        })
        .catch((e) => {
          this.gettingSessionFiles = false;
        });
    },
    async addSession() {
      if (
        this.CreatingSessionDate === "" ||
        this.CreatingSessionTitle === "" ||
        this.CreatingSessionLink === ""
      ) {
        this.$toast.add({
          severity: "error",
          detail: "لطفا تمام موارد را وارد کنید",
          life: 5000,
        });
        return;
      }
      this.addingSession = true;
      await axios
        .post("/api/v1/teacher/class/session/create", {
          classid: this.clickedClass.Id,
          uidclass: this.clickedClass.Uid,
          title: this.CreatingSessionTitle,
          disc: this.CreatingSessionDisc,
          link: this.CreatingSessionLink,
          startdate: this.CreatingSessionDate,
        })
        .then((response) => {
          if (response.data.status === "ok") {
            this.notiApi(
              true,
              true,
              "create",
              false,
              this.CreatingSessionDate,
              this.CreatingSessionTitle,
              this.CreatingSessionLink
            );

            this.addingSession = false;
            this.$toast.add({
              severity: "success",
              summary: "جلسه با موفقیت ایجاد شد",
              life: 5000,
            });
            this.CreatingSessionDate = "";
            this.CreatingSessionDisc = "";
            this.CreatingSessionLink = "";
            this.CreatingSessionTitle = "";
            this.sessions.push(response.data.data);
          } else {
            this.addingSession = false;
            this.$toast.add({
              severity: "error",
              summary: "خظای سرور",
              life: 5000,
            });
          }
        })
        .catch((e) => {
          this.addingSession = false;
        });
    },
    calcTitle() {
      if (!this.showCourse) {
        return "کلاس های آنلاین";
      } else {
        return this.clickedClass.Name;
      }
    },
    formatStatus(t) {
      return this.courseStatus.find((e) => e.Id === t).Name;
    },
    getCredentials() {
      this.me = JSON.parse(ls.get("user"));
      this.getCourses();
    },
    sendCourse(c) {
      this.selectedCourse = c;
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    async getCourses() {
      await axios
        .post("/api/v1/teacher/class", { techid: this.me.Id })
        .then((response) => {
          this.courses = response.data;
          this.isPreparing = false;
        });
      //this.$toast.add({severity:'success', summary: 'Success Message', detail:'Order submitted', life: 3000});
    },
    async getCourseCreds(c) {
      this.clickedClass = c;
      this.showCourse = true;
      this.isPreparing = true;
      this.scrollToTop();
      await axios
        .post("/api/v1/teacher/class/session", {
          id: c.Id,
        })
        .then((response) => {
          this.sessions = response.data.data;
        })
        .catch((e) => {
          this.isPreparing = false;
          this.showCourse = false;
        });
      await axios
        .post("/api/v1/teacher/class/get/student/in/class", {
          id: c.Id,
        })
        .then((response) => {
          this.students = response.data.data;
          this.filteredStudents = response.data.data;
        })
        .catch((e) => {
          this.isPreparing = false;
          this.showCourse = false;
        });

      this.isPreparing = false;
    },
    editCourse(course) {
      ls.set("editingCourse", course);
      ls.set("editingCourseId", course.Id);

      router.push({
        name: "EditCourse",
      });
    },
    formatCurrency(value) {
      return value.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
  },
};
</script>

<style></style>
